// const host = 'https://fdr-backend-1.onrender.com'
const host = 'https://api.restropilots.com'
// const host = 'http://localhost:3001'
const clienturl = 'http://www.restropilots.com/'
const clientID = "213757992493-dh2v71hib0a2iderrcm2gftss8vugcqe.apps.googleusercontent.com";
const GOOGLE_CLIENT_ID = "213757992493-dh2v71hib0a2iderrcm2gftss8vugcqe.apps.googleusercontent.com"
// const GOOGLE_CLIENT_ID = "500651936964-ft3qjuhl8orkco73ot5s9rv83vd3vh40.apps.googleusercontent.com"

// const GOOGLEAUTHCLIENTID='213757992493-dh2v71hib0a2iderrcm2gftss8vugcqe.apps.googleusercontent.com'
// const GOOGLEAUTHCLIENTSECRET='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'



const S3_BUCKET = 'restropilots';
const REGION    = 'ap-south-1';
const TAXES    = {'GST':{'SGST':2.5,'CGST':2.5},'OTHER':0}
const TAX_TYPE_ENUM = ['CGST', 'SGST', 'IGST', 'VAT', 'SERVICE_TAX', 'OTHER'];
const resolveTaxType = (key) => (TAX_TYPE_ENUM.includes(key) ? key : 'OTHER');


const convertToJpeg = (file, quality,max_image_dimension ) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);

      let { width, height } = img;
      if (width > max_image_dimension || height > max_image_dimension) {
        const scale = max_image_dimension / Math.max(width, height);
        width  = Math.round(width * scale);
        height = Math.round(height * scale);
      }

      const canvas = document.createElement('canvas');
      canvas.width  = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');

      // Flatten transparency onto white before encoding as JPEG.
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) { reject(new Error('Image conversion failed. Please try a different file.')); return; }
          resolve(blob);
        },
        'image/jpeg',
        quality
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Could not read that image file.'));
    };
    img.src = objectUrl;
  });

const checkLogin = async () => {
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${host}/user/vlogin`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${token}`
        },

      });
      // console.log("cafes are",response)
      if (response.ok) {

        return true


      } else {
        return false
      }
    } catch (error) {
      return false
      console.error("Error ", error)
    }
  }
  function formatDateTime(isoString) {
    if(!isoString){
      return ''
    }
    const date = new Date(isoString);
  
    const pad = (num) => (num < 10 ? '0' + num : num);
  
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are zero-indexed
    const year = date.getFullYear().toString().slice(-2);
  
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
  
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }


const computeTaxBreakdown = (taxableAmount) => {
  const breakdown = [];
  if (!taxableAmount || taxableAmount <= 0 || !TAXES) return breakdown;

  Object.entries(TAXES).forEach(([groupKey, groupValue]) => {
    if (typeof groupValue === 'number') {
      if (groupValue > 0) {
        const amount = Math.round(taxableAmount * groupValue) / 100;
        if (amount > 0) {
          breakdown.push({
            name: groupKey,
            type: resolveTaxType(groupKey),
            percentage: groupValue,
            amount,
          });
        }
      }
    } else if (groupValue && typeof groupValue === 'object') {
      Object.entries(groupValue).forEach(([subKey, pct]) => {
        if (typeof pct === 'number' && pct > 0) {
          const amount = Math.round(taxableAmount * pct) / 100;
          if (amount > 0) {
            breakdown.push({
              name: subKey,
              type: resolveTaxType(subKey),
              percentage: pct,
              amount,
            });
          }
        }
      });
    }
  });

  return breakdown;
};
export { host,checkLogin,formatDateTime ,clientID,clienturl,GOOGLE_CLIENT_ID,REGION,S3_BUCKET,TAXES,TAX_TYPE_ENUM,resolveTaxType,computeTaxBreakdown,convertToJpeg};